export default __webpack_public_path__ + "static/media/halotrade.b5aa51a8.png";